
export type MetricDtoTags = {[key: string]: string};
